import * as api from '../api.js';

export const getStat = async ({ type }, set, get) => {
  const {
    success: { stat },
  } = await api.getStat({ type });
  set({ stats: [stat] }, false, { type: 'getStat' });
};
